import Decimal from 'decimal.js-light';
import { formatUnits } from 'viem';

import { useFiatDisplay } from '@/hooks/useFiatDisplay';

import { type Fees } from '@/utils/0x.types';
import { TokenResult } from '@/utils/0x/token-registry.types';

interface GaslessGasFeeProps {
  fees: Fees;
  sellToken: TokenResult;
  buyToken: TokenResult;
  tokenUsdPrices: { buyTokenUsd: number; sellTokenUsd: number };
}

export const GaslessGasFeeUsd = ({
  fees,
  sellToken,
  buyToken,
  tokenUsdPrices,
}: GaslessGasFeeProps) => {
  const { buyTokenUsd, sellTokenUsd } = tokenUsdPrices;
  const { formatFiat } = useFiatDisplay();

  if (fees.gasFee === null) return null;
  const feeToken = fees.gasFee.token === sellToken.address ? sellToken : buyToken;
  const feeTokenUsd = fees.gasFee.token === sellToken.address ? sellTokenUsd : buyTokenUsd;
  const gasFeeAmount = new Decimal(
    formatUnits(BigInt(fees.gasFee.amount), Number(feeToken.decimals)),
  );

  const gasFeeUsd = gasFeeAmount.times(feeTokenUsd);
  const formattedGasFeeUsd = formatFiat(gasFeeUsd);

  return <span className="text-token-gray-1600 line-through">{formattedGasFeeUsd}</span>;
};
